var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23.25 6.75C22.0095 6.75 21 5.7405 21 4.5C21 4.086 20.664 3.75 20.25 3.75H3.75C3.336 3.75 3 4.086 3 4.5C3 5.7405 1.9905 6.75 0.75 6.75C0.336 6.75 0 7.086 0 7.5V16.5C0 16.914 0.336 17.25 0.75 17.25C1.9905 17.25 3 18.2595 3 19.5C3 19.914 3.336 20.25 3.75 20.25H20.25C20.664 20.25 21 19.914 21 19.5C21 18.2595 22.0095 17.25 23.25 17.25C23.664 17.25 24 16.914 24 16.5V7.5C24 7.086 23.664 6.75 23.25 6.75ZM22.5 15.825C21.033 16.1235 19.875 17.283 19.575 18.75H16.5V17.25H15V18.75H4.425C4.125 17.283 2.967 16.125 1.5 15.825V8.175C2.967 7.875 4.125 6.717 4.425 5.25H15V6.75H16.5V5.25H19.575C19.875 6.717 21.033 7.875 22.5 8.175V15.825Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.5 8.25H15V11.25H16.5V8.25Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.5 12.75H15V15.75H16.5V12.75Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.75 6.75C5.5095 6.75 4.5 7.7595 4.5 9C4.5 10.2405 5.5095 11.25 6.75 11.25C7.9905 11.25 9 10.2405 9 9C9 7.7595 7.9905 6.75 6.75 6.75ZM6.75 9.75C6.336 9.75 6 9.414 6 9C6 8.586 6.336 8.25 6.75 8.25C7.164 8.25 7.5 8.586 7.5 9C7.5 9.414 7.164 9.75 6.75 9.75Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.25 12.75C10.0095 12.75 9 13.7595 9 15C9 16.2405 10.0095 17.25 11.25 17.25C12.4905 17.25 13.5 16.2405 13.5 15C13.5 13.7595 12.4905 12.75 11.25 12.75ZM11.25 15.75C10.836 15.75 10.5 15.414 10.5 15C10.5 14.586 10.836 14.25 11.25 14.25C11.664 14.25 12 14.586 12 15C12 15.414 11.664 15.75 11.25 15.75Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.23 6.92393C12.9105 6.65843 12.438 6.70193 12.174 7.01993L4.67399 16.0199C4.40849 16.3379 4.45199 16.8119 4.76999 17.0774C4.90949 17.1929 5.08049 17.2499 5.24999 17.2499C5.46599 17.2499 5.67899 17.1584 5.82749 16.9799L13.3275 7.97993C13.5915 7.66193 13.548 7.18793 13.23 6.92393Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }